import { HotelSeoContentPropertiesType } from "@website/accommodation-ui/hotel-seo-content/hotel-seo-content.types";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";

export const useSeoContent = (properties: HotelSeoContentPropertiesType) => {
  const router = useRouter();
  const { list } = properties;
  return {
    list:
      list &&
      list.map((item) => ({
        title: item.title,
        imageUrl: item.imageUrl,
        videoUrl: item.videoUrl,
        content: numberConvert(
          item.description?.replaceAll(/style="[^"]*"|<br\s*\/?>/g, ""),
          { locale: router.locale }
        )
      }))
  };
};
